export default function SettingsDirective() {
  return {
    template: require('./settings.html'),
    controller: 'SettingsController',
    controllerAs: 'settingsVM',
    bindToController: true,
    replace: true,
  };
}
